/**
 * SuggestionRow styles — values lifted from the approved design (dark surface, podium avatar).
 * Colors are brand tokens from the Zporti dark design system.
 */

import { StyleSheet } from 'react-native'

export const SUGGESTION_AVATAR_SIZE = 48

const COLORS = {
  card: '#1F2937',
  border: 'rgba(255,255,255,0.05)',
  text: '#F7FAFC',
  muted: '#9CA3AF',
  dim: '#6B7280',
  lavender: '#A78BFA',
  onLavender: '#111827',
  mint: '#6EE7B7',
  outline: '#374151',
} as const

export const suggestionRowStyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: COLORS.card,
    borderWidth: 1,
    borderColor: COLORS.border,
    borderRadius: 14,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  avatarZone: {
    width: 52,
    height: 52,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 15,
    fontWeight: '700',
    color: COLORS.text,
  },
  reasonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginTop: 1,
  },
  reasonText: {
    fontSize: 12,
    color: COLORS.muted,
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    flexShrink: 0,
  },
  addButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: COLORS.lavender,
    borderRadius: 9999,
    paddingVertical: 8,
    paddingHorizontal: 15,
  },
  addButtonLabel: {
    fontSize: 13,
    fontWeight: '700',
    color: COLORS.onLavender,
  },
  addedButton: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: COLORS.outline,
  },
  addedButtonLabel: {
    color: COLORS.mint,
  },
  dismissButton: {
    width: 32,
    height: 32,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
})

export const SUGGESTION_ROW_COLORS = COLORS
